<template>
  <v-list two-line>
    <SubHeader :name="title" />
    <DraggableContent :items="items" @content-array="updateContentList" />
  </v-list>
</template>

<script>
import DraggableContent from './ModularComponent/DraggableContent.vue';
import SubHeader from './ModularComponent/SubHeader.vue';

  export default {
    components: {
      DraggableContent,
      SubHeader
    },
    props: {'items': { type: Array, Default: [] }, 'title': { type: String, Default: ''}},
    methods:{
      updateContentList(val) {
        this.$emit('update-list', val)
      }
    }
    
  }
</script>

<style scoped>

</style>